<template>
    <div class="top-page" :class="{ 'back': isBackStyle }">
        <div>Top Page</div>
    </div>
</template>
<script>
export default {
    name: "TopPage",
    props: {
        scrollObserve: Object,
    },
    data: function() {
        return {
            isBackStyle: false,
        };
    },
    created: function() {
        this.scrollObserve.subscribe((position) => {
            // console.log("scroll position: " + position);
            this.scrollEvent(position);
        });
    },
    methods: {
        scrollEvent: function(position) {
            if (position > 10) {
                this.isBackStyle = true;
            } else {
                this.isBackStyle = false;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .top-page {
        padding: 10px;
        position: fixed;
        width: 100vw;
        height: 50px;
        top: 0px;
        border-bottom: 1px solid #000;
        color: #000;
        transition-duration: 1s;

        &.back {
            color: #fff;
            background: #000;
        }
    }
</style>
